import { GridColDef } from '@mui/x-data-grid';
import { isValid } from 'date-fns';
import { formatDate, formatDateWithTime, parseDate } from '../../../utils/format';
import { renderCellOrDefault } from '../renderCellOrDefault';

export const dateGridColDef: Pick<GridColDef, 'valueGetter' | 'sortComparator' | 'renderCell'> = {
  valueGetter: (params) => {
    if (!params.value) {
      return params.value;
    }
    const date = new Date(params.value);

    return formatDate(date) ?? params.value;
  },
  sortComparator: (v1, v2) => {
    const date1 = parseDate(v1);
    const date2 = parseDate(v2);
    if (!isValid(date2)) {
      return 1;
    }
    if (!isValid(date1)) {
      return -1;
    }
    return date1.getTime() - date2.getTime();
  },
  renderCell: renderCellOrDefault,
};
export const dateTimeGridColDef: Pick<GridColDef, 'valueGetter' | 'sortComparator' | 'renderCell'> = {
  valueGetter: (params) => {
    const date = new Date(params.value);
    return formatDateWithTime(date) ?? params.value;
  },
  sortComparator: (v1, v2) => {
    const date1 = parseDate(v1);
    const date2 = parseDate(v2);
    if (!isValid(date2)) {
      return 1;
    }
    if (!isValid(date1)) {
      return -1;
    }
    return date1.getTime() - date2.getTime();
  },
  renderCell: renderCellOrDefault,
};
